export default "__VITE_ASSET__NdFEZ7ui__"